
    import common from "@/util/common.ts";
    import {useStore} from "@/store";
    import checkItem from './checkItem/checkItem.vue';
    import batteryDetectH5 from '../../batteryDetect/batteryDetectH5/index.vue';
    import batteryDetectH5SOH from '../../batteryDetect/batteryDetectH5SOH/index.vue';
    import batteryDetectH5SOHRu from '../../batteryDetect/batteryDetectH5SOHRu/index.vue';
    import batteryDetectH5Ru from '../../batteryDetect/batteryDetectH5Ru/index.vue';
    import {defineComponent, computed, ComputedRef, watch, reactive, toRefs} from "vue";

    interface State {
        dataList: object[];
        flawList: object[];
        tocOnlyShowFlaw: boolean;
        batteryDetectH5StyleCode: string;
    }
    export default defineComponent({
        name: 'checkCont',
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                dataList: [],
                flawList: [],
                tocOnlyShowFlaw: false,
                batteryDetectH5StyleCode: ''
            });
            const {renderData} = toRefs(props);
            console.log('renderData', renderData);
            function getData(list, code, key='value', type='') {
                return common.getDataByCode(list,  code, key, type)
            }
            // for (let i = 0; i< renderData.value.length; i += 1) {
            //     let item = renderData.value[i];
            //     let configItems = item.configItems;
            //     let defectCount = Number(getData(configItems, 'defectCount'));
            //     if (defectCount > 0) {
            //         state.flawList.push(item);
            //     }
            // }
            let store = useStore();
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {checkModuleList, componentList} = JSON.parse(JSON.stringify(data));
                const batteryDetect = componentList.find(item => item.code === 'batteryDetect');
                state.batteryDetectH5StyleCode = batteryDetect && batteryDetect.styleCode;
            }, {immediate: true, deep: true})
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            state.dataList = renderData.value;
            watch(tocOnlyShowFlawS, (data: any) => {
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})
            
            return {
                state,
                getData
            }
        },
        components: {
            checkItem,
            batteryDetectH5,
            batteryDetectH5SOH,
            batteryDetectH5SOHRu,
            batteryDetectH5Ru
        }
    })
